import React from 'react';
import FadeIn from '../components/ui/FadeIn';

const Datenschutz = () => {
  return (
    <div className="pt-32 pb-20 bg-brand-cream min-h-screen">
      <div className="container mx-auto px-6 max-w-4xl">
        <FadeIn>
          <h1 className="text-4xl font-serif mb-12 border-b border-brand-rose pb-6">Datenschutzerklärung</h1>
          
          <div className="prose prose-brand max-w-none space-y-8 text-brand-text">
            <section>
              <h2 className="text-2xl font-serif text-brand-dark mb-4">1. Datenschutz auf einen Blick</h2>
              <p>
                Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie die Website <strong>glowconsulting.de</strong> besuchen.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-serif text-brand-dark mb-4">2. Datenerfassung auf dieser Website</h2>
              <p>
                Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber:
                <br /><br />
                Rukiye Amini<br />
                Axel-Springer-Platz 3<br />
                20355 Hamburg<br />
                E-Mail: hallo@glowconsulting.de
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-serif text-brand-dark mb-4">3. Kontaktformular</h2>
              <p>
                Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben zwecks Bearbeitung der Anfrage bei uns gespeichert. Wir nutzen diese Daten ausschließlich zur Beantwortung Ihres Anliegens bei glowconsulting.de.
              </p>
            </section>
          </div>
        </FadeIn>
      </div>
    </div>
  );
};

export default Datenschutz;